<template>
    <div class="all">
      <div style="width:1200px;margin:0 auto;">
        <div class="chooseBtn">
          <div class="lease" @click="chooseTypeFn(1)" :class="{active:chooseType===1}">租赁商品<div class='corner'><div class="number">{{leaseNum>99?"99+":leaseNum}}</div></div></div>
          <div class="consumable" @click="chooseTypeFn(2)" :class="{active:chooseType===2}">耗材商品<div class='corner'><div class="number">{{consumableNum>99?"99+":consumableNum}}</div></div></div>
        </div>
        <table class="table" v-if="shopCartArr.length>0">
          <tr>
            <th class="th1">
              <img class="kuang" :src="!allChoose?kuangImg[0]:kuangImg[1]" alt="" @click="chooseCheck">
              <p>全选</p>
            </th>
            <th class="th2">商品</th>
            <th v-show="chooseType===1">月租金</th>
            <th v-show="chooseType===1">押金</th>
            <th v-show="chooseType===2">单价</th>
            <th>数量</th>
            <th v-show="chooseType===1">首付金额</th>
            <th v-show="chooseType===2">小计</th>
<!--            <th style="width: 170px" v-show="chooseType===1">起租日期</th>-->
            <th v-show="chooseType===1">租期</th>
            <th style='width:100px'>操作</th>
          </tr>

          <tr :class="{contTr:index!==shopCartArr.length-1}" v-for="(item,index) in shopCartArr" :key="item.id">
            <td class="td1">
              <img v-if="!item.check" class="kuang" :src="kuangImg[0]" alt="" @click="clickCheck(index)">
              <img v-if="item.check" class="kuang" :src="kuangImg[1]" alt="" @click="clickCheck(index)">
              <div class="line" v-show="index!==shopCartArr.length-1"></div>
            </td>
            <td class="td2" @click="skipDetails(item)">
              <div class="imgDiv">
                <img class="headerImg" :src="item.sku.product.product_main_pic" alt="">
              </div>
              <div class="imgRig">
                <div :title="item.sku && item.sku.product && item.sku.product.name" class="goodName">{{item.sku && item.sku.product && item.sku.product.name}}</div>
                <p :title="item.sku.allocation" class="specification">{{item.sku.allocation}}</p>
              </div>
            </td>
            <td>￥{{getFlootPrice(item.monthSent)}}</td>
            <td v-show="chooseType===1">￥{{getFlootPrice(item.cashPledge)}}</td>
            <td>
              <div class="shopNum">
                <p class="reduce" @click="changeShopNum(index, 1)">-</p>
                <!--                <input class="count" type="text" v-model="shopNumArr[chooseType - 1][index]" @input="getValue(index)" @blur="blurFn(index)" @focus="focus(index)">-->
                <input class="count" type="number" v-model="shopNumArr[chooseType - 1][index]" @blur="changeShopNum(index,3)" @focus="focus(index)">
                <p class="add" @click="changeShopNum(index, 2)">+</p>
              </div>
            </td>
            <td>￥{{getFlootPrice(item.subtotal)}}</td>
<!--            <td v-show="chooseType===1">-->
<!--              <div class="leaseRig">-->
<!--                <p class="leaseDate" :id="'getDate'+index" @click="leaseDate(index)">{{item.lease_time}}</p>-->
<!--                <img class="dateIcon" src="../assets/lease/date.png" alt="">-->
<!--              </div>-->
<!--            </td>-->
            <td v-show="chooseType===1">
<!--              <select style="outline: none;" v-model="item.month_num" id="" @change="changeMonthNum(index)">-->
<!--                <option :value="monthItem" v-for="(monthItem,monthIndex) in monthNumArr" :key="monthIndex">{{monthItem}}</option>-->
<!--              </select>-->
              <span>{{item.sku.charter}}</span>
              <span class="span3">个月</span>
            </td>
            <td class="td6">
              <!-- <div style="cursor:pointer;color:#FF4527" @click="showPopoutFn(index)">删除</div> -->
              <el-button type="text" @click="clickConfirm(index)">删除</el-button>
              <div v-show="index!==shopCartArr.length-1" class="line2"></div>
              <!-- 没货时出现遮罩 -->
              <div class='shopMask' v-if='shopNumArr[chooseType - 1][index]>item.sku.stock'></div>
            </td>
          </tr>
        </table>
        <table class="table" v-else>
          <tr>
            <th class="th1">
              <img class="kuang" :src="!allChoose?kuangImg[0]:kuangImg[1]" alt="" @click="chooseCheck">
              <p>全选</p>
            </th>
            <th class="th2">商品</th>
            <th v-show="chooseType===1">月租金</th>
            <th v-show="chooseType===1">押金</th>
            <th v-show="chooseType===2">单价</th>
            <th>数量</th>
            <th v-show="chooseType===1">首付金额</th>
            <th v-show="chooseType===2">小计</th>
            <!--            <th style="width: 170px" v-show="chooseType===1">起租日期</th>-->
            <th v-show="chooseType===1">租期</th>
            <th>操作</th>
          </tr>
          <tr class="noData">暂无数据</tr>
        </table>
        <div class="settleAccounts">
          <div class="botLeft">
            <img class="kuang" :src="!allChoose?kuangImg[0]:kuangImg[1]" alt="" @click="chooseCheck">
            <p>全选</p>
          </div>
          <div class="botRig">
            <div class="yesChoose">
              <span>已选择</span>
              <span class="redSpan">{{chooseShop}}</span>
              <span>件商品</span>
            </div>
            <div class="allPrice">
              <span class="allPriceWord">总价：</span>
              <span class="priceMoney">￥{{getFlootPrice(allMoney)}}</span>
            </div>
            <div class="payBtn" @click="payMoney">去结算</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
let _shopNumArr = [] // 商品数量
export default {
  name: 'shopCart',
  data () {
    return {
      deleIndex: 0, // 删除的商品下标
      chooseType: 1, // 选择地势租赁商品1，还是耗材2
      shopCartArr: [], // 购物车列表
      leaseArr: [], // 租赁商品数据
      consumableArr: [], // 耗材商品数据
      shopNumArr: [[], []], // 商品数量
      kuangImg: [require('../assets/lease/kuang.png'), require('../assets/lease/yesKuang.png')], // 选中与未选中icon
      allChoose: false, // 判断全选
      againClick: true, // 防止重复点击
      chooseShop: 0, // 已选择的商品
      allMoney: 0, // 总价
      checkArr: [], // 选中的商品数据
      nowDate: '', // 起租日期
      // monthNumArr: [12, 24, 36] // 租期
      leaseNum: 0, // 租赁商品数量
      consumableNum: 0 // 耗材商品数量
    }
  },
  computed: {
    ...mapState({
      shopNum: state => state.shopNum
    })
  },
  mounted () {
    window.scrollTo(0, 0)
    this.getData()
  },
  methods: {
    // 显示弹框  //确认删除或取消删除商品
    clickConfirm (index) {
      this.deleIndex = index
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteFn(this.deleIndex)
      }).catch(() => {

      })
    },
    // 保留两位小数并且向上取整
    getFlootPrice (price) {
      return (Math.ceil(price / 100 * 100) / 100).toFixed(2)
    },
    // 跳转到详情
    skipDetails (item) {
      let type = 1
      if (item.sku.product.category === 'lease') {
        type = 1
      } else {
        type = 2
      }
      const url = this.$router.resolve({
        path: './deviceDetails',
        query: {
          type: type,
          sku_id: item.sku_id,
          product_id: item.sku.product_id
        }
      })
      window.open(url.href, '_blank')
    },
    // 计算首期租金
    getFirstMoney (price, pledgeMoney, num) {
      let balance = 0 // 首期租金
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      let days = new Date(year, month, 0)
      days = days.getDate() // 当月总天数
      const nowDate = date.getDate() // 当前日期
      if (nowDate <= 15) {
        balance = (Math.ceil(price * (days - nowDate) / days) + pledgeMoney) * num // 首期的实际租金+押金
      } else {
        balance = (Math.ceil(price * (days - nowDate) / days) + price + pledgeMoney) * num // 首期的实际租金+押金
      }
      console.log('当月总天数', days)
      console.log('当前日期', nowDate)
      console.log('首期租金', balance)
      return balance
    },
    changeMonthNum (index) { // 修改租期
      console.log(this.shopCartArr)
      const params = {
        id: this.shopCartArr[index].id,
        num: this.shopNumArr[this.chooseType - 1][index],
        lease_time: this.shopCartArr[index].lease_time,
        month_num: this.shopCartArr[index].month_num
      }
      this.axios.post('/product/edit_cart', params).then(res => {
        if (res.code === 0) {
          this.allMoney = 0
          console.log(this.shopCartArr)
          if (this.chooseType === 1) {
            this.$set(this.leaseArr[index], 'month_num', res.datas.month_num)
            this.shopCartArr[index].subtotal = this.shopCartArr[index].sku.price2 / 100 * this.shopNumArr[this.chooseType - 1][index]
            this.leaseArr[index].subtotal = this.shopCartArr[index].subtotal
          } else {
            this.shopCartArr[index].subtotal = this.shopCartArr[index].sku.price2 / 100 * this.shopNumArr[this.chooseType - 1][index]
          }
          if (this.shopCartArr[index].check) {
            for (let i = 0; i < this.checkArr.length; i++) {
              if (this.shopCartArr[index].id === this.checkArr[i].id) {
                this.checkArr[i].subtotal = this.shopCartArr[index].subtotal
              }
              this.allMoney += this.checkArr[i].subtotal
            }
          }
        } else {
          this.$layer.msg(res.msg, { time: 1.5 })
        }
      })
    },
    chooseTypeFn (e) { // 选择租赁还是耗材
      this.chooseShop = 0
      this.checkArr = []
      this.allMoney = 0
      this.allChoose = false
      if (e === 1) {
        this.chooseType = 1
        this.shopCartArr = JSON.parse(JSON.stringify(this.leaseArr))
        this.leaseNum = this.shopCartArr.length
      } else {
        return
        this.chooseType = 2
        this.shopCartArr = JSON.parse(JSON.stringify(this.consumableArr))
        this.consumableNum = this.shopCartArr.length
      }
      console.log(this.shopCartArr)
      console.log(this.shopNumArr)
    },
    // leaseDate (index) { // 选择时间日期
    //   const id = '#getDate' + index
    //   window.laydate.render({
    //     elem: id,
    //     btns: ['now'], // clear、now、confirm
    //     done: (value, date, endDate) => {
    //       console.log(value)
    //       const params = {
    //         id: this.shopCartArr[index].id,
    //         num: this.shopNumArr[this.chooseType - 1][index],
    //         lease_time: value,
    //         month_num: this.shopCartArr[index].month_num
    //       }
    //       this.axios.post('/product/edit_cart', params).then(res => {
    //         if (res.code === 0) {
    //           this.$set(this.shopCartArr[index], 'lease_time', value)
    //           this.$set(this.leaseArr[index], 'lease_time', value)
    //         } else {
    //           this.$layer.msg(res.msg, { time: 1.5 })
    //         }
    //       })
    //     }
    //   })
    // },
    getNowDate () { // 获取当前日期
      const nowDate = new Date()
      const year = nowDate.getFullYear()
      let month = nowDate.getMonth() + 1
      let date = nowDate.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    focus (index) {
      _shopNumArr = JSON.parse(JSON.stringify(this.shopNumArr))
    },
    blurFn (index) {
      if (!this.shopNumArr[this.chooseType - 1][index]) {
        this.$set(this.shopNumArr[this.chooseType - 1], index, _shopNumArr[this.chooseType - 1][index])
      }
    },

    deleteFn (index) { // 删除
      const params = {
        id: this.shopCartArr[index].id
      }
      this.axios.post('product/delete_cart', params).then(res => {
        if (res.code === 0) {
          this.$store.commit('setShopNum', this.shopNum - 1)
          if (this.shopCartArr[index].check) {
            for (let i = 0; i < this.checkArr.length; i++) {
              if (this.checkArr[i].id === this.shopCartArr[index].id) {
                this.checkArr.splice(i, 1)
                break
              }
            }
          }
          this.chooseShop = this.checkArr.length
          if (this.checkArr.length > 0) {
            this.allMoney = 0
            for (let i = 0; i < this.checkArr.length; i++) {
              this.allMoney += this.checkArr[i].subtotal
            }
          } else {
            this.allMoney = 0
          }
          if (this.chooseType === 1) {
            this.leaseArr.splice(index, 1)
            this.leaseNum = this.leaseArr.length
          } else {
            this.consumableArr.splice(index, 1)
            this.consumableNum = this.leaseArr.length
          }
          this.shopCartArr.splice(index, 1)
        }
      }).catch((e) => {
        this.$layer.msg(e, { time: 1.5 })
      })
    },
    // 检测认证有效期是否已过期
    deadlineOvertime () {
      const userInfo = this.$requestAll.getUserInfo()
      const deadlineDate = userInfo.audit_deadline.slice(0, 10)
      const deadline = new Date(deadlineDate).getTime() // 企业有效期到期时间戳
      const nowDate = this.getNowDate()
      const nowDateTime = new Date(nowDate).getTime() // 当前时间戳
      if (deadline >= nowDateTime) {
        return true
      } else {
        return false
      }
    },
    getNowDate () {
      const today = new Date()
      const y = today.getFullYear()
      let m = today.getMonth() + 1
      let d = today.getDate()
      const h = today.getHours()
      const i = today.getMinutes()
      const s = today.getSeconds()
      m = this.changeTime(m)
      d = this.changeTime(d)
      return y + '-' + m + '-' + d
    },
    // 时间不足10的前面加0
    changeTime (time) {
      if (time < 10) {
        time = '0' + time
      }
      return time
    },
    payMoney () { // 结算
      if (this.checkArr.length === 0) {
        this.$layer.msg('请选择商品', { time: 1.5 })
        return
      }
      const userInfo = this.$requestAll.getUserInfo()
      if (userInfo.audit_state !== 'adopt') {
        this.$layer.msg('请先到 [一键报修-企业认证] 中进行认证', { time: 3 })
        return
      }
      if (!this.deadlineOvertime()) {
        this.$layer.msg('认证已过期，请重新认证', { time: 3 })
        return
      }
      const jiance = this.checkArr.some((item) => {
        return item.num > item.sku.stock
      })
      if (jiance) {
        this.$layer.msg('选中的商品库存不足', { time: 3 })
        return
      }
      sessionStorage.setItem('shopOrderData', JSON.stringify(this.checkArr))
      this.$store.commit('setShopOrderData', this.checkArr)
      this.$router.push({
        path: './submitOrder',
        query: {
          chooseType: this.chooseType
        }
      })
    },
    // 修改商品数量
    changeShopNum (index, e) {
      console.log('修改商品数量')
      if (!this.againClick) {
        return
      }

      const numArr = JSON.parse(JSON.stringify(this.shopNumArr))
      if (e === 1) {
        if (numArr[this.chooseType - 1][index] > 1) {
          this.$set(numArr[this.chooseType - 1], index, numArr[this.chooseType - 1][index] - 1)
        } else if (numArr[this.chooseType - 1][index] === 1) {
          return
        }
      } else if (e === 2) {
        if (numArr[this.chooseType - 1][index] === this.shopCartArr[index].sku.stock) {
          this.$layer.msg('数量超出范围', { time: 1.5 })
          return
        }
        this.$set(numArr[this.chooseType - 1], index, numArr[this.chooseType - 1][index] + 1)
      } else {
        this.shopNumArr[this.chooseType - 1][index] = parseInt(this.shopNumArr[this.chooseType - 1][index])
        if (!this.shopNumArr[this.chooseType - 1][index]) {
          this.$set(this.shopNumArr[this.chooseType - 1], index, _shopNumArr[this.chooseType - 1][index])
          return
        }
        if (this.shopNumArr[this.chooseType - 1][index] > this.shopCartArr[index].sku.stock) {
          this.$layer.msg('数量超出范围', { time: 1.5 })
          setTimeout(() => {
            this.$set(this.shopNumArr[this.chooseType - 1], index, _shopNumArr[this.chooseType - 1][index])
          }, 1500)
          return
        }
      }
      this.againClick = false
      const params = {
        id: this.shopCartArr[index].id,
        num: numArr[this.chooseType - 1][index],
        lease_time: this.shopCartArr[index].lease_time,
        month_num: this.shopCartArr[index].month_num
      }
      this.axios.post('/product/edit_cart', params).then(res => {
        this.againClick = true
        if (res.code === 0) {
          this.$set(this.shopNumArr[this.chooseType - 1], index, res.datas.num)
          this.shopCartArr[index].num = this.shopNumArr[this.chooseType - 1][index]
          this.leaseArr[index].num = this.shopCartArr[index].num
          if (this.chooseType === 1) {
            this.$set(this.leaseArr[index], 'num', res.datas.num)
            this.shopCartArr[index].subtotal = this.getFirstMoney(this.shopCartArr[index].sku.price2, this.shopCartArr[index].sku.price, this.shopNumArr[this.chooseType - 1][index])
            this.leaseArr[index].subtotal = this.shopCartArr[index].subtotal
            this.shopCartArr[index].cashPledge = this.shopCartArr[index].sku.price * this.shopNumArr[this.chooseType - 1][index]
            this.leaseArr[index].cashPledge = this.shopCartArr[index].cashPledge
            this.shopCartArr[index].monthSent = this.shopCartArr[index].sku.price2 * this.shopNumArr[this.chooseType - 1][index]
            this.leaseArr[index].monthSent = this.shopCartArr[index].monthSent
            console.log(this.shopCartArr)
            console.log(this.checkArr)
          } else {
            this.$set(this.consumableArr[index], 'num', res.datas.num)
            this.shopCartArr[index].subtotal = this.shopCartArr[index].sku.price2 / 100 * this.shopNumArr[this.chooseType - 1][index]
            this.consumableArr[index].subtotal = this.shopCartArr[index].subtotal
          }
          if (!this.shopCartArr[index].check) {
            return
          }
          this.allMoney = 0
          if (this.shopCartArr[index].check) {
            for (let i = 0; i < this.checkArr.length; i++) {
              if (this.shopCartArr[index].id === this.checkArr[i].id) {
                this.checkArr[i].subtotal = this.shopCartArr[index].subtotal
                this.checkArr[i].num = this.shopNumArr[this.chooseType - 1][index]
              }
              this.allMoney += this.checkArr[i].subtotal
            }
          }
        } else {
          const goodsNum = JSON.parse(JSON.stringify(this.shopNumArr))
          this.$layer.msg(res.msg, { time: 1.5 })
          this.$set(this.shopNumArr[this.chooseType - 1], index, _shopNumArr[this.chooseType - 1][index])
        }
      })
    },
    getData () { // 获取购物车数据
      const userId = JSON.parse(sessionStorage.getItem('userInfo')).id
      const params = {
        where: [{ k: 'user_id', v: userId, op: '=' }]
      }
      this.$geturl({ url: 'list/shopping_cart', method: 'get', params }).then(res => {
        if (res.code === 0) {
          for (let i = 0; i < res.datas.length; i++) {
            res.datas[i].check = false
            if (!res.datas[i].lease_time) {
              res.datas[i].lease_time = this.getNowDate()
            }
            // this.$nextTick().then(() => {
            //   this.leaseDate(i)
            // })

            if (res.datas[i].sku.product && res.datas[i].sku.product.category === 'lease') {
              const skuData = res.datas[i].sku
              skuData.allocation = ''
              for (let j = 0; j < skuData.spu_values.length; j++) {
                skuData.allocation += skuData.spu_values[j].name + ':' + skuData.spu_values[j].values + '/'
              }
              skuData.allocation = skuData.allocation.slice(0, skuData.allocation.length - 1)

              res.datas[i].subtotal = this.getFirstMoney(res.datas[i].sku.price2, res.datas[i].sku.price, res.datas[i].num)
              res.datas[i].cashPledge = res.datas[i].sku.price * res.datas[i].num
              res.datas[i].monthSent = res.datas[i].sku.price2 * res.datas[i].num
              this.leaseArr.push(res.datas[i])

              // this.leaseArr[0].sku.stock = 0

              this.shopNumArr[0].push(res.datas[i].num)
              this.leaseNum = this.leaseArr.length
            } else if (res.datas[i].sku.product && res.datas[i].sku.product.category === 'consumables') {
              res.datas[i].subtotal = res.datas[i].sku.price2 * res.datas[i].num
              this.consumableArr.push(res.datas[i])
              this.shopNumArr[1].push(res.datas[i].num)
              this.consumableNum = this.consumableArr.length
            }
          }
          this.shopCartArr = JSON.parse(JSON.stringify(this.leaseArr))
          console.log(this.shopCartArr)
        }
      })
    },
    chooseCheck () { // 全选
      this.checkArr = []
      this.allMoney = 0
      this.allChoose = !this.allChoose
      console.log(this.shopCartArr)
      for (let i = 0; i < this.shopCartArr.length; i++) {
        if (this.allChoose) {
          if (this.shopCartArr[i].sku.stock >= this.shopNumArr[this.chooseType - 1][i]) {
            this.shopCartArr[i].check = true
            this.checkArr.push(this.shopCartArr[i])
            // this.checkArr = JSON.parse(JSON.stringify(this.shopCartArr))
          }
        } else {
          this.checkArr = []
          this.shopCartArr[i].check = false
          this.allMoney = 0
        }
      }
      if (this.checkArr.length > 0) {
        this.allMoney = 0
        for (let i = 0; i < this.checkArr.length; i++) {
          this.allMoney += this.checkArr[i].subtotal
        }
      } else {
        this.allMoney = 0
      }
      console.log(this.checkArr)
      this.chooseShop = this.checkArr.length
    },
    clickCheck (index) { // 单个选择
      this.$set(this.shopCartArr[index], 'check', !this.shopCartArr[index].check)
      const allChoose = this.shopCartArr.filter((item, e, arr) => {
        return item.sku.stock >= item.num
      })
      if (this.shopCartArr[index].check) {
        this.checkArr.push(this.shopCartArr[index])
        if (allChoose.length === this.checkArr.length) {
          this.allChoose = true
        }
      } else {
        for (let i = 0; i < this.checkArr.length; i++) {
          if (this.shopCartArr[index].id === this.checkArr[i].id) {
            this.checkArr.splice(i, 1)
            break
          }
        }
        if (allChoose.length > this.checkArr.length) {
          this.allChoose = false
        }
      }
      console.log(this.checkArr)
      if (this.checkArr.length > 0) {
        this.allMoney = 0
        for (let i = 0; i < this.checkArr.length; i++) {
          this.allMoney += this.checkArr[i].subtotal
        }
      } else {
        this.allMoney = 0
      }
      this.chooseShop = this.checkArr.length
    }
  }
}
</script>

<style scoped>
  .shopMask{
    position: absolute;
    top: 0px;
    left: -1098px;
    width: 1198px;
    height: 210px;
    background-color:#999999;
    opacity: 0.3;
  }
  .corner{
    width: 18px;
    height:18px;
    text-align: center;
    line-height:16px;
    /* padding: 0 3px; */
    background-color: #FF4F3C;
    position: absolute;
    top: -8px;
    right: -10px;
    border-radius:50%;
    font-size: 12px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .number{
    transform: scale(0.7);
  }
  .chooseBtn{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 1200px;
    margin: 0 auto 20px auto;
  }
  .lease{
    margin-right: 20px;
  }
  .lease,.consumable{
    padding: 10px 20px;
    /*background-color: #548E9E;*/
    border: 1px solid #548E9E;
    border-radius: 6px;
    font-size: 14px;
    font-weight: bold;
    color: #666666;
    cursor:pointer;
    position: relative;
  }
  .consumable{
    cursor:not-allowed;
  }
  .active{
    background-color: #548E9E;
    color: #ffffff;
  }

  .all{
    width: 100%;
    margin: 0 auto;
    padding: 30px 0 100px 0;
    background-color: #f2f2f2;
  }
  .table{
    width: 100%;
    border: 1px solid #DADEE6;
    box-sizing: border-box;
    table-layout:fixed;
    border-collapse:collapse;
    background-color: #ffffff;
    word-break:break-all;
    /* position: relative; */
  }
  .table th{
    background-color: #DADEE6;
    height: 40px;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    color: #333333;
  }
  .table .th1{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 40px;
    box-sizing: border-box;
  }
  .table .th2{
    width: 300px;
    /*padding-right: 50px;*/
  }
  .table .th1 p{
    margin-left: 12px;
  }
  .kuang{
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  td{
    vertical-align: top;
    padding: 38px 0;
    font-size: 12px;
    font-weight: bold;
    color: #666666;
    text-align: center;
  }
  .table .td1{
    padding-left: 40px;
    box-sizing: border-box;
    position: relative;
  }
  .table .td2{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    cursor: pointer;
    /*padding-right: 50px;*/
  }
  .goodName{
    text-align: left;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
    word-break: break-all;
  }
  .imgDiv{
    width: 131px;
    height: 131px;
    border: 1px solid #E6E6E6;
    margin-right: 20px;
  }
  .headerImg{
    width: 131px;
    height: 131px;
    object-fit: contain;
  }
  .settleAccounts{
    width: 1200px;
    height: 60px;
    background-color: #ffffff;
    margin: 20px auto 0 auto;
    padding-left: 40px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .botLeft,.botRig{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .botLeft p{
    margin-left: 12px;
    font-size: 12px;
    font-weight: 500;
    color: #333333;
  }
  .allPrice{
    margin: 0 40px 0 74px
  }
  .yesChoose span{
    font-size: 12px;
    font-weight: 500;
    color: #999999;
    vertical-align: middle;
  }
  .yesChoose .redSpan{
    font-size: 16px;
    font-weight: 500;
    color: #FF4527;
    margin: 0 3px;
  }
  .allPrice span{
    vertical-align: middle;
  }
  .allPriceWord{
    font-size: 12px;
    font-weight: 500;
    color: #999999;
  }
  .priceMoney{
    font-size: 18px;
    font-weight: 500;
    color: #FF4527;
  }
  .payBtn{
    width: 140px;
    height: 60px;
    background: #FF4527;
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 60px;
    cursor: pointer;
  }
  .contTr{
    border-bottom: 1px solid #DADEE6;
    box-sizing: border-box;
  }
  .line{
    width: 40px;
    height: 10px;
    background-color: #ffffff;
    position: absolute;
    left: 0px;
    bottom: -5px;
  }
  .table .td6{
    position: relative;
  }
  .line2{
    width: 40px;
    height: 10px;
    background-color: #ffffff;
    position: absolute;
    right: 0px;
    bottom: -5px;
  }
  .shopNum{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .reduce,.add{
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: #f2f2f2;
    cursor:pointer;
  }
  .shopNum .count{
    width: 50px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border:1px solid #DADEE6;
    box-sizing: border-box;
  }
  .leaseRig{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 140px;
    height: 30px;
    border: 1px solid #E6E6E6;
    padding-right: 10px;
    box-sizing: border-box;
    margin: 0 auto;
  }
  .leaseDate{
    font-size: 14px;
    font-weight: bold;
    color: #666666;
    padding-left: 10px;
  }
  .noData{
    width: 1200px;
    height: 209px;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #666666;
  }
  .specification{
    margin-top: 15px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    word-break: break-all;
  }
</style>
